export type RequestBody = string | { [key: string]: any } | FormData;

interface IRequestErrorProps {
  message: string;
  type?: string;
  code?: string;
  data?: Record<string, any>;
}

export const getBasicHeaders = () => {
  const headers = new Headers();

  headers.set('Accept', 'application/json');
  headers.set('Content-Type', 'application/json');

  return headers;
};

export const stringifyRequestBody = (body?: RequestBody): string | FormData | undefined => {
  if (typeof body === 'string' || body instanceof FormData || typeof body === 'undefined') {
    return body;
  }
  return JSON.stringify(body);
};

export const getRequestErrorData = async (response: Response): Promise<IRequestErrorProps> => {
  try {
    const body = await response.json();
    const message = getErrorMessage(body, response);
    const type = getErrorType(body);
    const code = getErrorCode(body);
    const data = getErrorData(body);

    return { message, type, code, data };
  } catch (error) {
    return { message: response.statusText };
  }
};

const getErrorMessage = (body: IRequestErrorProps, response: Response) => {
  return body.message || response.statusText;
};

const getErrorType = (body: IRequestErrorProps) => {
  if (!body.type) {
    return;
  }

  return body.type;
};

const getErrorCode = (body: IRequestErrorProps) => {
  if (!body.code) {
    return;
  }

  return body.code;
};

const getErrorData = (body: IRequestErrorProps) => {
  if (!body.data) {
    return;
  }

  return body.data;
};
